import { EvolucionTipoVisitaMes } from '../services/dashboard.service';
import { SERIES_EVOLUCION_TIPOS_VISITA } from './tipo-visita.utils';
import { formatChileanNumber } from './numeros.util';

export interface ColumnaTablaFullscreen {
  key: string;
  label: string;
  align?: 'left' | 'center';
  /** Si true, la celda se formatea con chileanNumber (cantidad entera). */
  numerica?: boolean;
  /** Si true, la celda es porcentaje con chileanNumber:1 y sufijo %. */
  porcentaje?: boolean;
}

export interface TablaFullscreen {
  columnas: ColumnaTablaFullscreen[];
  filas: Record<string, string | number>[];
}

/**
 * Tabla de distribución (dona, estado planes): categoría, cantidad y %.
 */
export function construirTablaDistribucion(
  datos: { label: string; value: number }[]
): TablaFullscreen {
  const columnas: ColumnaTablaFullscreen[] = [
    { key: 'categoria', label: 'Categoría', align: 'left' },
    { key: 'cantidad', label: 'Cantidad', align: 'center', numerica: true },
    { key: 'porcentaje', label: '%', align: 'center', porcentaje: true }
  ];

  const total = datos.reduce((acc, d) => acc + Number(d.value), 0);
  const filas = datos.map(d => {
    const value = Number(d.value);
    const pct = total > 0 ? (value / total) * 100 : 0;
    return {
      categoria: d.label,
      cantidad: value,
      porcentaje: pct
    };
  });

  return { columnas, filas };
}

/**
 * Tabla de evolución mensual: mes + columnas por tipo de visita + total.
 */
export function construirTablaEvolucion(datos: EvolucionTipoVisitaMes[]): TablaFullscreen {
  const columnas: ColumnaTablaFullscreen[] = [
    { key: 'mes', label: 'Mes', align: 'left' },
    ...SERIES_EVOLUCION_TIPOS_VISITA.map(serie => ({
      key: serie.campo,
      label: serie.label,
      align: 'center' as const,
      numerica: true
    })),
    { key: 'total', label: 'Total', align: 'center', numerica: true }
  ];

  const filas = datos.map(mes => {
    const fila: Record<string, string | number> = { mes: mes.label };
    let total = 0;
    for (const serie of SERIES_EVOLUCION_TIPOS_VISITA) {
      const valor = Number(mes[serie.campo]) || 0;
      fila[serie.campo] = valor;
      total += valor;
    }
    fila['total'] = total;
    return fila;
  });

  return { columnas, filas };
}

/** Formatea valor de celda para tooltip o export (no usado en template si hay pipe). */
export function formatearCeldaTabla(
  valor: string | number,
  columna: ColumnaTablaFullscreen
): string {
  if (columna.porcentaje) {
    return `${formatChileanNumber(Number(valor), 1)}%`;
  }
  if (columna.numerica) {
    return formatChileanNumber(Number(valor), 0);
  }
  return String(valor);
}
